import { Dictionary, omitBy, reduce } from 'lodash';

export function keyByWithValue<T = string | number, R = boolean>(
  collection: ArrayLike<T>,
  value: ((item: T) => R) | R,
  iteratee?: (item: T) => string | number,
) {
  return reduce(
    collection,
    (result, item) => {
      const key = iteratee ? iteratee(item) : (item as string | number);
      if (typeof value === 'function') {
        result[key] = (value as (item: T) => R)(item);
      } else {
        result[key] = value;
      }

      return result;
    },
    {} as { [key: string | number]: R },
  );
}

export function omitEmptyProps(object?: Dictionary<any>) {
  return omitBy(object, (val) => val === null || val === undefined);
}

export function assignDefined(source: Dictionary<any>) {
  return omitBy(source, (val) => val === undefined);
}
